export default __webpack_public_path__ + "static/GreenBuildingStandards-aa791d122dff96039f9d2144fb1fbd7c.jpg";